import { createAction } from '@ngrx/store';
import { ActionCreator } from '@ngrx/store/src/models';
import { UserSettings } from 'app/modules/main/models/user-settings';

export type LoadUserSettingsAction = ActionCreator;

export class UserSettingsActions {

  static readonly userSettingsLoaded =
    createAction(
      '[User Settings Feature] User Settings Loaded',
      (userSettings: UserSettings) => ({ userSettings }),
    );

  static readonly userSettingsLoadFailed =
    createAction(
      '[User Settings Feature] User Settings Load Failed',
      (error?: string) => ({ error }),
    );

}
